import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { SearchFilter, IFilterResponse } from 'src/app/infrastructure/iFilter-component';
import { SearchFilterComponent } from '../../search-filter/search-filter.component';
import { PagerControlComponent } from '../../controls/pager/pager-control.component';
import { MenuService } from 'src/app/services/menu.service';
import { MedicalFeeService } from 'src/app/services/medical-fee/medical-fee.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { MedicalFeePaymentService } from 'src/app/services/medical-fee/medical-fee-payment.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog.service';
import { Router } from '@angular/router';
import { MedicalFeePaymentManualSearchItem } from 'src/app/model/medical-fee/medical-fee-payment-manual-search-item';
import { ReportViewerDialogComponent } from '../../dialogs/report-viewer/report-viewer-dialog/report-viewer-dialog.component';
import { MedicalFeePaymentSearchItem } from 'src/app/model/medical-fee/medical-fee-payment-search-item';

@Component({
  selector: 'app-medical-fee-payment-search',
  templateUrl: './medical-fee-payment-search.component.html',
  styleUrls: ['./medical-fee-payment-search.component.css']
})
export class MedicalFeePaymentSearchComponent implements OnInit {

  displayedColumns: string[] = ['Id', 'Physician', 'Amount', 'PayDate', 'MedicalFeePeriodName', 'Star'];
  dataSource = new MatTableDataSource([]);
  loading: boolean;
  loadingAction: boolean;
  searchFilters: SearchFilter[];

  @ViewChild('searchFilter', {static: false}) searchFilter: SearchFilterComponent;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;

  constructor( private menuService: MenuService,
               private medicalFeeService: MedicalFeeService,
               private notificationToastService: NotificationToastService,
               private dialog: MatDialog,
               private mfpManualService: MedicalFeePaymentService,
               private confirmDialogService: ConfirmDialogService,
               private route: Router ) {
    this.menuService.setMenuTitle('Honorarios', 'Consulta liquidación');
  }

  ngOnInit() {
  }

  selectedPageIndexChange(pagedItems: any[]) {

    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch( response: IFilterResponse<MedicalFeePaymentSearchItem> ) {
    this.searchFilters = response.searchFilters;
    this.pager.setItems(response.items);
    this.loading = false;
  }

  onStartSearch() {
    this.loading = true;
  }

  cancel( item: MedicalFeePaymentSearchItem ) {

    this.confirmDialogService.confirm( 'Cancelar honorarios',
      'Está seguro que desea cancelar los honorarios?', 'Sí', 'No' )
      .subscribe( value => {

        if ( value ) {

          this.mfpManualService.cancelMedicalFeeBill( item.Id );
          this.searchFilter.search();
        }

      });
  }

  async viewReport( item: MedicalFeePaymentSearchItem ) {

    try {
      item.Loading = true;
      const reportViewer = await this.medicalFeeService
            .getMedicalFeeReport(item.Id, false);
      this.dialog.open(ReportViewerDialogComponent, {
        width: '90%',
        height: '600px',
        data: reportViewer
      });
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Honorarios');
    } finally {
      item.Loading = false;
    }
  } 
}
